import { PaymentStatus } from 'constants/payment';
import { useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { LoadingState } from 'views/shared/loading-state';

import { BaseCard, LogoKassaStyle } from '../ui';

const PreloaderView = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { t } = useTranslate();

  return (
    <BaseCard>
      <div className="bg-white md:bg-base-gray-100 flex-grow w-full h-full md:rounded-large flex flex-col col-start-1 col-end-3 justify-center items-center text-center gap-8 p-8">
        <LoadingState
          className="text-black"
          dotClassName="bg-black"
          logoStyle={LogoKassaStyle.DARK}
          message={
            paymentData?.status === PaymentStatus.WAIT_PROCESSING ||
            paymentData?.status === PaymentStatus.WAIT_PAYMENT_CONFIRM
              ? t('lang.you_will_be_redirected_to_bank_page_to_confirm_payment')
              : t('lang.loading')
          }
        />
      </div>
    </BaseCard>
  );
};

export { PreloaderView };
